import { render, staticRenderFns } from "./GridHealth.vue?vue&type=template&id=20fb1f0f&"
import script from "./GridHealth.vue?vue&type=script&lang=js&"
export * from "./GridHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports